'use strict';

angular.module('magtac')
  .service('timersConfigViewModel', [
    'TimerConfig', 'timerConfigDetailsViewModel', 'modalService', 'modalDialogService', 'timerFormatService', 'StatusPageLookup',
    function (TimerConfig, timerConfigDetailsViewModel, modalService, modalDialogService, timerFormatService, lookup) {

      var viewModel = function (companyId) {

        var self = this;

        self.mode = "Monitor";

        TimerConfig.getServers(companyId).then(function(resp){
          self.servers = resp;
        });
        
        TimerConfig.getAvailableTasks(companyId).then(function(resp){
          self.availableTasks = resp;
        });

        TimerConfig.getDefaultTasksConfigurations().then(function(resp){
          self.defaultConfigurations = resp;
        });

        TimerConfig.getAdHocQueries().then(function (resp) {
          self.adHocQueries = resp;
        });

        lookup.observerNames().then(function (data) {
          self.observerNames = data;
        });

        self.getInstanceName = function(item) {
          if (!item.Parameters || !item.Parameters.instances || !self.availableTasks || !self.availableTasks.length) {
            return null;
          }

          var task = _.find(self.availableTasks, { Name: item.TaskName })

          if (!task) {
            return item.Parameters.instances;
          }

          var instance = _.find(task.Parameters.instances, { path: item.Parameters.instances });

          return instance ? instance.description + '(' + instance.path + ')' : item.Parameters.instances;
        }

        self.reload = function (custStatus) {
          TimerConfig.get(companyId).then(function (resp) {
            self.timers = resp;
            if (!!custStatus){
              custStatus.reloadData();
            }
          });
        };

        self.getTimeZone = function(offset){
          var zoneAbbrs = [];
          var serverOffset = offset * -1;
          var zoneNames = moment.tz.names().filter(function(zoneName){
            return zoneName.indexOf("America") > -1;
          });  

          zoneNames.forEach(function(zoneName){
            var zone = moment.tz(zoneName)._z;
            if(zone.offsets.some(function(offset){
              return offset == serverOffset;
            })){
              var offsetindex = zone.offsets.indexOf(serverOffset);
              if(zoneAbbrs.indexOf(zone.abbrs[offsetindex]) == -1){
                zoneAbbrs.push(zone.abbrs[offsetindex]);              
              }              
              return;
            }
          });
          return zoneAbbrs;
        }

        self.getTime = function (timer) {
            if (!timer || !timer.CronConfiguration) return timer?.CronConfiguration || '';

            const serverTimeZone = timer.Server?.TimeZoneOffset;
            const serverOffset = serverTimeZone * 60;
            const serverZoneAbbr = self.getTimeZone(serverOffset); // returns array?

            const clientOffset = moment.tz(new Date(), moment.tz.guess()).utcOffset();
            const clientTimeZone = clientOffset / 60;
            const clientZoneAbbr = moment.tz(new Date(), moment.tz.guess()).format('z');

            let checkForCron = true;
            const clientFormatted = timerFormatService.formatTime(timer.CronConfiguration, clientTimeZone, checkForCron);

            if (!clientFormatted?.isCron) {
                // It's a custom label, just return it
                return clientFormatted?.string || timer.CronConfiguration;
            }

            // If it's a cron string, compare with server output
            checkForCron = false;
            const serverFormatted = timerFormatService.formatTime(timer.CronConfiguration, serverTimeZone, checkForCron);

            const clientStr = `${clientFormatted.string} (${clientZoneAbbr})`;

            if (clientFormatted.string === serverFormatted) {
                return clientStr; // Same time, no need to show server version
            }

            const serverStr = `${serverFormatted} (${serverZoneAbbr.join?.('/') || serverZoneAbbr})`;

            return `${clientStr} / ${serverStr}`;
        };

        self.edit = function (custStatus, item) {
          var detailsViewModel = new timerConfigDetailsViewModel(item || { CompanyId: companyId, SubTasks: [] }, 
            self.servers, angular.copy(self.defaultConfigurations), self.observerNames, self.timers, self.adHocQueries);
          detailsViewModel.on('save', function () {
            self.reload(custStatus);
          });
          detailsViewModel.on('delete', function (params) {
            self.reload(custStatus);
          });
          modalService.showWindow('components/magtac/customerStatus/timersConfig/timerConfig-details.html', detailsViewModel);
        };

        self.delete = function(custStatus, item) {
          modalDialogService.showConfirmation('Are you sure want to delete this timer configuration? This action cannot be undone.', 'Delete confirmation', 'dialog - danger').then(function (result) {
                            if (result) {
                                console.log(result);

                            TimerConfig.delete(item).then(function() {
                self.reload(custStatus);
              });
                        } else {
                            console.log("Confirmation rejected");
                        }
                    });
          
        };

        self.setRunNow = function(custStatus, item, flagOn) {
          var detailsViewModel = new timerConfigDetailsViewModel(item || { CompanyId: companyId, SubTasks: [] }, 
            self.servers, angular.copy(self.defaultConfigurations), self.observerNames, self.timers, self.adHocQueries);
          detailsViewModel.item.RunNow = flagOn;
          detailsViewModel.on('save', function () {
            self.reload(custStatus);
          });
          detailsViewModel.save();
        };

        self.reload();
      };

      return viewModel;

    }
  ]);
